var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconNorthStar = function SvgIconNorthStar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-bcf5ac69-e9df-487c-a0ce-8c132b09b646",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-097415f3-2384-4c67-87fd-190f762f5c66{fill:#f9f9ee;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-097415f3-2384-4c67-87fd-190f762f5c66",
    d: "M.46,6.3c2.89,0,5.24,2.35,5.24,5.24.16.18.44.18.61,0,0-2.89,2.35-5.24,5.24-5.24.18-.16.18-.44,0-.61-2.89,0-5.24-2.35-5.24-5.24-.16-.18-.44-.18-.61,0C5.7,3.35,3.35,5.7.46,5.7c-.18.16-.18.44,0,.61Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconNorthStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-northStar.6455e7ec0938b96a6fa4be864d405d5b.svg";